import { Component, Input, ElementRef, AfterContentInit } from "@angular/core";
import { SafeUrl, DomSanitizer } from "@angular/platform-browser";

import { domAccessor } from "@jct/ui/lib/services";

@Component({
  selector: "ui-mail-link",
  templateUrl: "./ui-mail-link.component.html",
  styleUrls: ["./ui-mail-link.component.scss"],
  exportAs: "uiMailLink",
})
export class MailLinkComponent implements AfterContentInit {
  constructor(
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef<HTMLElement>
  ) {}

  @Input()
  color: "primary" | "accent" | "warn" | "" = "";

  trustedUrl: SafeUrl;

  ngAfterContentInit() {
    let text = domAccessor(this.elementRef).query("mat-icon + span").text();

    this.trustedUrl = this.sanitizer.bypassSecurityTrustUrl(`mailto:${text}`);
  }
}
